export default "__VITE_ASSET__Cde3z598__"